import type { ChatMessageType } from '@/store/types';

export type AidaMessageTurn = {
  id: string;
  user?: ChatMessageType;
  bots: ChatMessageType[];
};

export function groupAidaMessageTurns(messages: ChatMessageType[]): AidaMessageTurn[] {
  const turns: AidaMessageTurn[] = [];
  let current: AidaMessageTurn | null = null;

  for (const message of messages) {
    if (message.sender === 'user') {
      if (current) turns.push(current);
      current = { id: message.id, user: message, bots: [] };
      continue;
    }

    if (!current) {
      current = { id: `bot-turn-${message.id}`, bots: [message] };
      continue;
    }

    current.bots.push(message);
  }

  if (current) turns.push(current);
  return turns;
}
